export const openCameraSettings = (): void => {
    const ua = navigator.userAgent.toLowerCase();

    if (/iphone|ipad|ipod/.test(ua)) {
        // iOS: opens iOS Settings app (Safari only)
        window.open('app-settings:');
    } else if (/android/.test(ua)) {
        // Android Chrome: tries to open site settings
        window.open('chrome://settings/content/camera');
    } else {
        // Desktop fallback: instruct user manually
        alert(
            'To enable camera access, click the lock icon in your browser address bar.'
        );
    }
};
